import PlatformUsers from "./PlatformUsers";

/**
 * Users & Access — the tenant's platform users, reached from the Settings
 * landing page (/pam/settings/users). PlatformUsers renders the whole page in
 * the Settings design language (SettingsPage header with the "Add users"
 * action, stats, filters, list, and pagination); this file only names it.
 */
export default function PlatformUsersPage() {
  return (
    <PlatformUsers
      title="Users & Access"
      description="People with an account on this tenant. Review their role, enrolled MFA factors, and account status."
    />
  );
}
